export interface CommonReduxState {
	enableUploadButton: boolean;
	otpModalVisible: boolean;
	snackbarState: ISnackBarState;
	storredUserData: {
		[key: string]: any;
	};
	product: string;
}

export interface ISnackBarState {
	isOpen: boolean;
	message: string;
	type: snackBarType;
}

export enum snackBarType {
	error,
	success,
	info,
}

export enum ObjectType {
	DROPFILE = 1,
	SENDFILE = 2,
	ISHIPDOCS = 3,
}

export enum ActionType {
	mark_location_info_failed = 9,
	start_login_failed = 10,
	verify_otp_failed = 11,
	refresh_token_failed = 12,
	order_quote_failed = 13,
	order_item_update_failed = 14,
	mark_order_complete_failed = 15,
	s3_bucket_details_failed = 16,
	upload_file_missing_local_map = 17,
	single_file_upload_failed = 18,
	upload_pipeline_failed = 19,
	safe_upload_task_failed = 20,
	zip_information_failed = 21,
}

export enum SourceType {
	WEB = 1,
	DEVICE = 2,
	MOBILE = 3,
}

export enum LogStatus {
	ERROR = 1,
	WARN = 2,
	INFO = 3,
}
